import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { string, func, arrayOf, shape, node } from 'prop-types';
import { Share } from '@magalu/stereo-ui-icons';
import { Container, Content, Circle } from './social-share.styles';

function SocialShare(_ref) {
  let {
    socialItems,
    onItemClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["socialItems", "onItemClick"]);

  const [open, setOpen] = useState(false);

  const handleToggleOpen = () => {
    setOpen(!open);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      handleToggleOpen();
    }
  };

  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "aria-label": "Compartilhar",
    role: "button",
    "aria-haspopup": "true",
    "aria-expanded": open,
    onClick: handleToggleOpen,
    onKeyDown: handleKeyDown,
    tabIndex: "0"
  }), /*#__PURE__*/React.createElement(Share, {
    height: "24",
    color: "#818181",
    "data-testid": "social-share",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(Content, {
    open: open,
    "data-testid": "social-content"
  }, socialItems.map(({
    title,
    url,
    Icon
  }) => /*#__PURE__*/React.createElement(Circle, {
    key: title,
    href: url,
    target: "_blank",
    onClick: e => onItemClick(e, title),
    "aria-label": title
  }, Icon))));
}

process.env.NODE_ENV !== "production" ? SocialShare.propTypes = {
  socialItems: arrayOf(shape({
    url: string.isRequired,
    title: string.isRequired,
    Icon: node.isRequired
  })),
  onItemClick: func
} : void 0;
SocialShare.defaultProps = {
  socialItems: [],
  onItemClick: () => {}
};
export default SocialShare;